import React from 'react';
import logo from '../../tathya-logo.png';

const TCLogo = ({ size = 60 }) => (
  <img
    src={logo}
    alt="CONSAM Logo"
    width={size}
    height={size}
    style={{ borderRadius: '8px' }}
  />
);

export default TCLogo;
